// src/services/doctorService.js
import axios from '@/axios'

export default {
  async fetchDoctors(clinicId) {
    const { data } = await axios.get(`/clinics/${clinicId}/doctors`)
    return data.doctors || []
  },

  async fetchIndividualDoctors() {
    const { data } = await axios.get('/admin/individual-doctors')
    return data.doctors || []
  },

  async createIndividualDoctor(payload) {
    return axios.post('/admin/individual-doctors', payload)
  },

  async deleteIndividualDoctor(doctorId) {
    return axios.delete(`/admin/individual-doctors/${doctorId}`)
  },

  async deleteClinicDoctor(doctorId) {
    return axios.delete(`/admin/clinics/doctors/${doctorId}`)
  },

  async updatePassword(doctorId, payload) {
    return axios.post(`/admin/clinics/doctors/${doctorId}/password`, {
      ...payload,
      _method: 'PATCH'
    })
  },

  async assignChief(doctorId) {
    return axios.post(`/admin/clinics/doctors/${doctorId}/chief`, {
      _method: 'PATCH'
    })
  },

  async revokeChief(doctorId) {
    return axios.post(`/admin/clinics/doctors/${doctorId}/revoke-chief`, {
      _method: 'PATCH'
    })
  }
}
